import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fieldset, Input, UniversalSelect } from '@feathr/components';
import { flattenError } from '@feathr/hooks';

import type { IExportTypeOption, IPersonFieldOption } from '../GroupExportModal.utils';
import type { ISimpleExportFormState } from './SimpleExportForm.hooks';

export interface ISimpleExportFormProps {
  state: ISimpleExportFormState;
}

function SimpleExportForm({ state }: Readonly<ISimpleExportFormProps>): JSX.Element {
  const { t } = useTranslation();

  const {
    email,
    emailHadFocus,
    emailError,
    exportTypeOptions,
    selectedExportTypeOption,
    isCustomFieldsPending,
    fieldOptions,
    selectedFieldOptions,
    fieldsError,
    handleChangeMode,
    handleChangeEmail,
    handleEmailBlur,
    handleSelectFields,
  } = state;

  return (
    <Fieldset>
      <UniversalSelect<IExportTypeOption>
        label={t('Export type')}
        name={'export-type'}
        onSelectSingle={handleChangeMode}
        options={exportTypeOptions}
        value={selectedExportTypeOption}
      />
      <UniversalSelect<IPersonFieldOption>
        isLoading={isCustomFieldsPending}
        isMulti={true}
        label={t('Fields')}
        menuPortalTarget={document.body}
        name={'export-fields'}
        onSelectMulti={handleSelectFields}
        options={fieldOptions}
        validationError={flattenError(fieldsError)}
        value={selectedFieldOptions}
      />
      <Input
        helpText={t('If you want to send the report to a different email address.')}
        isClearable={true}
        label={t('Email address')}
        onBlur={handleEmailBlur}
        onChange={handleChangeEmail}
        type={'text'}
        validationError={emailHadFocus ? flattenError(emailError) : undefined}
        value={email}
      />
    </Fieldset>
  );
}

export default SimpleExportForm;
